'use strict';

var React = require('react');
var functions = require('../../helpers/functions.js');
require('../../theme/breakpoints.js');
var useClickAway = require('../../hooks/useClickAway.js');
require('imask');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var index = require('../Flex/index.js');
var component = require('../Text/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderNavItemDesktop = React.forwardRef(({ tab, subItems, isActive, mouseDelay = 100, overlayVariant = 'align-left', ...props }, ref) => {
    const headerNavItemRef = useRefAndForward.useRefAndForward(null, ref);
    const overlayRef = React.useRef(null);
    const [isOverlayOpened, setOverlayOpened] = React.useState(false);
    const debouncedChangeCallback = React.useMemo(() => functions.debounce(mouseDelay)(setOverlayOpened), [mouseDelay, setOverlayOpened]);
    const onMouseLeave = React.useCallback(() => debouncedChangeCallback(false), [debouncedChangeCallback]);
    const onMouseEnter = React.useCallback(() => debouncedChangeCallback(true), [debouncedChangeCallback]);
    useClickAway.useClickAway({ listener: onMouseLeave, containerRefs: [overlayRef, headerNavItemRef] });
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(styles.Styled.Tab, { ...props, ref: headerNavItemRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isActive: isOverlayOpened || isActive },
            React__default.default.createElement(index.Flex.Row, { space: "xs" },
                React__default.default.createElement(component.Text, { variant: "body", as: "div" }, tab),
                subItems && (React__default.default.createElement(styles.Styled.DropdownIcon, { name: "down-filled", "aria-label": "open sub items", onTouchStart: () => setOverlayOpened(!isOverlayOpened) })))),
        subItems && (React__default.default.createElement(styles.Styled.Overlay, { ref: overlayRef, variant: overlayVariant, isOpened: isOverlayOpened, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, targetRef: headerNavItemRef }, subItems))));
});

exports.HeaderNavItemDesktop = HeaderNavItemDesktop;
//# sourceMappingURL=Desktop.js.map
